<template>
<div class="flex min-h-screen bg-gray-50 dark:bg-gray-900">

<!-- Sidebar -->
<HrSidebar :isOpen="isSidebarOpen"/>

<main class="flex-1 transition-all duration-300" :class="{'ml-64':isSidebarOpen,'ml-0':!isSidebarOpen}">

<!-- Topbar -->
<header class="fixed top-0 w-full z-50 bg-white dark:bg-gray-800 shadow">
<HrTopbar
:page-title="currentPageTitle"
:is-sidebar-open="isSidebarOpen"
:is-dark-mode="isDarkMode"
@toggle-sidebar="toggleSidebar"
@toggle-dark-mode="toggleDarkMode"
/>
</header>

<div class="p-6 mt-16">

<!-- Search + Button -->
<div class="flex justify-between mb-8 p-4">

<input
v-model="search"
type="text"
placeholder="Search subject..."
class="border rounded-lg px-4 py-2 w-72 dark:bg-gray-700 dark:text-white"
/>

<button
@click="openModal"
class="bg-[#74bd54] text-white px-5 py-2 rounded-lg hover:bg-[#63a43f]"
>
+ Add Subject
</button>

</div>

<!-- Subjects Grid -->

<div v-if="filteredSubjects.length" class="grid md:grid-cols-3 lg:grid-cols-4 gap-6">

<div
v-for="subject in filteredSubjects"
:key="subject.id"
class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg"
>

<div class="flex items-center space-x-3 mb-4">

<div class="w-12 h-12 bg-secondary text-white flex items-center justify-center rounded-full font-bold">
{{ subject.code }}
</div>

<div>

<h3 class="font-semibold text-gray-800 dark:text-white">
{{ subject.name }}
</h3>

<span class="text-xs text-gray-500">
School Subject
</span>

</div>

</div>

<p class="text-sm text-gray-500 mb-6">
{{ subject.description }}
</p>

<div class="flex justify-between text-sm">

<button
@click="editSubject(subject)"
class="text-blue-600 hover:underline"
>
Edit
</button>

<button
@click="deleteSubject(subject.id)"
class="text-red-500 hover:underline"
>
Delete
</button>

</div>

</div>

</div>

<div v-else class="text-center text-gray-400 mt-20">
No subjects created yet
</div>

<!-- Modal -->

<Transition name="modal">

<div
v-if="showModal"
class="fixed inset-0 bg-black/40 flex items-center justify-center"
>

<div class="bg-white dark:bg-gray-800 rounded-xl p-6 w-[420px]">

<h3 class="text-lg font-semibold text-[#035a76] mb-6">
{{ editing ? "Edit Subject" : "Create Subject" }}
</h3>

<form @submit.prevent="saveSubject" class="space-y-4">

<input
v-model="form.name"
type="text"
placeholder="Subject Name"
required
class="w-full border rounded p-2 dark:bg-gray-700 dark:text-white"
/>

<input
v-model="form.code"
type="text"
placeholder="Code (ENG, MTH...)"
required
class="w-full border rounded p-2 dark:bg-gray-700 dark:text-white"
/>

<textarea
v-model="form.description"
placeholder="Description"
class="w-full border rounded p-2 dark:bg-gray-700 dark:text-white"
></textarea>

<div class="flex justify-end space-x-3">

<button
type="button"
@click="closeModal"
class="px-4 py-2 bg-gray-300 rounded"
>
Cancel
</button>

<button
type="submit"
class="px-4 py-2 bg-[#74bd54] text-white rounded hover:bg-[#63a43f]"
>
Save
</button>

</div>

</form>

</div>

</div>

</Transition>

</div>

</main>
</div>
</template>

<script setup>

import {ref,computed,onMounted} from "vue"
import api from "@/services/api"
import HrSidebar from "@/components/hr/HrSidebar.vue"
import HrTopbar from "@/components/hr/HrTopbar.vue"

const currentPageTitle = ref("Subjects")

const isSidebarOpen = ref(true)
const isDarkMode = ref(false)

const showModal = ref(false)
const editing = ref(false)

const search = ref("")

const subjects = ref([])

// const subjects = ref([
// {
// id:1,
// name:"English",
// code:"ENG",
// description:"English Language"
// },
// {
// id:2,
// name:"Mathematics",
// code:"MTH",
// description:"Mathematics subject"
// }
// ])

const fetchSubjects = async () => {
  try{
    const response = await api.get("Subjects.php");
    subjects.value = response.data.map(subject => ({
      id:subject.id,
      name:subject.name,
      code:subject.code,
      description:subject.description
    }));

  } catch (error) {
    console.error("Error fetching Subjects:", error);
  }
};

const form = ref({
id:null,
name:"",
code:"",
description:""
})

const filteredSubjects = computed(()=>{
return subjects.value.filter(s=>
s.name.toLowerCase().includes(search.value.toLowerCase())
)
})

const openModal=()=>{
editing.value=false
form.value={id:null,name:"",code:"",description:""}
showModal.value=true
}

const editSubject=(subject)=>{
editing.value=true
form.value={...subject}
showModal.value=true
}

// const saveSubject=()=>{

// if(editing.value){

// const index=subjects.value.findIndex(s=>s.id===form.value.id)
// subjects.value[index]={...form.value}

// }else{

// subjects.value.push({
// id:Date.now(),
// ...form.value
// })

// }

// closeModal()

// }

const saveSubject = async () =>{
  try{
  let response;

  if(editing.value){
    response = await api.put("Subjetcs.php", form.value)
    const index = subjects.value.findIndex(s => s.id === form.value.id)
      if (index !== -1) {
        sections.value[index] = { ...form.value };
      }
      
  }else{
        response = await api.post("Subjects.php", form.value)
        subjects.value.push({
          id:response.data.id,
          name:response.data.name,
          code:response.data.code,
          description:response.data.description
        });
      }
closeModal();

  } catch (error) {
    console.error("Error saving section:", error);
  }
};

// const deleteSubject=(id)=>{
// subjects.value=subjects.value.filter(s=>s.id!==id)
// }

const deleteSubject = async (id) => {
try {

    await api.delete("Subjects.php", {
      data: { id: id }
    });

    subjects.value = subjects.value.filter(s => s.id !== id);

  } catch (error) {
    console.error("Error deleting subject:", error);
  }
}

const closeModal=()=>{
showModal.value=false
}

const toggleSidebar=()=>{
isSidebarOpen.value=!isSidebarOpen.value
}

const toggleDarkMode=()=>{
isDarkMode.value=!isDarkMode.value

if(isDarkMode.value){
document.documentElement.classList.add("dark")
}else{
document.documentElement.classList.remove("dark")
}

}
onMounted(() =>{
    fetchSubjects();
})

</script>

<style>

.modal-enter-active,
.modal-leave-active{
transition:all .25s ease;
}

.modal-enter-from{
opacity:0;
transform:scale(.9);
}

.modal-leave-to{
opacity:0;
transform:scale(.9);
}

</style>